import { Box, Menu, MenuItem } from "@mui/material"
import useMenu from "../../../hooks/useMenu"


const FinalMarkField = ({ value, onChange }) => {

    const { anchorEl, open, handleDefaultMenuClick, handleMenuClose } = useMenu()

    const handleMenuClick = value => {
        onChange(value)
        handleMenuClose()
    }

    return <>
        <Box
            onClick={handleDefaultMenuClick}
            sx={{
                width: 33,
                height: 33,
                display: "flex", justifyContent: "center", alignItems: "center",
                cursor: "pointer",
                transition: "background 0.3s, opacity 0.3s",
                "&:hover": {
                    background: "#CCCCCCAA",
                    transition: "background 0.3s, opacity 0.3s"
                }
            }}
        >
            {value}
        </Box>
        <Menu open={open} onClose={handleMenuClose} anchorEl={anchorEl}>
            <MenuItem onClick={() => handleMenuClick(2)}>2</MenuItem>
            <MenuItem onClick={() => handleMenuClick(3)}>3</MenuItem>
            <MenuItem onClick={() => handleMenuClick(4)}>4</MenuItem>
            <MenuItem onClick={() => handleMenuClick(5)}>5</MenuItem>
        </Menu>
    </>
}

export default FinalMarkField